export enum EPlacingLayoutType {
  packagesWithoutBet = 'packagesWithoutBet',
  packages = 'packages',
  services = 'services',
}
